import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { ReactSVG } from "react-svg";
import styles from "./RecipeCard.module.scss";
import { RecipeElementType } from "./RecipeCard";

type DifficultyBoxProps = Pick<
  RecipeElementType,
  "difficultyLevel" | "isClickOut"
>;

export const DifficultyBox = ({
  difficultyLevel,
  isClickOut,
}: DifficultyBoxProps) => {
  const { getIcon } = useGlobalContext();

  if (isClickOut) {
    return (
      <div className={styles["tiptopf-logo"]}>
        <ReactSVG
          src={getIcon("tiptopfLogo")}
          wrapper="svg"
          width={77}
          height={21}
          aria-hidden
        />
      </div>
    );
  }

  return (
    <div className={styles["level-category"]}>
      <p className="recipe-card-category-label">{difficultyLevel.label}</p>
      {Array.from({ length: 3 }).map((_, idx) => (
        <ReactSVG
          key={`level-catefory-${idx}`}
          src={getIcon("levelCategory")}
          wrapper="svg"
          width={19}
          height={19}
          aria-hidden
          opacity={idx + 1 <= difficultyLevel.level ? 1 : 0.5}
        />
      ))}
    </div>
  );
};
